import React from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {getText} from 'helpers/language-helper';
import {checkIfModuleIsUnlocked, getPlayerModuleData} from 'helpers/module-helper';
import {playerUiTexts} from 'data/ui-texts/player-ui-texts';
import {modulesData} from 'data/modules-data';
import './modules-overview.scss';

const ModulesOverview = ({languageId, backgroundStatus, deviceInfo, playerData, handleGoToGamePage}) => {

	/**
	 * Handle go to module
	 * @param {bool} isUnlocked 
	 * @param {string} moduleId 
	 */
	const handleGoToModule = (isUnlocked, moduleId) => {
		if (
			isUnlocked || 
			appConfig.env === 'development' || 
			appConfig.env === 'test' ||
			appConfig.env === 'demo'
		) {
			handleGoToGamePage('module', moduleId);	
		}
	};

	if (backgroundStatus !== 'show') return null;

	return (
		<div className={'ModulesOverview ' + deviceInfo.orientation}>
			{/* Home btn */}
			<div className="ModulesOverview-homeBtn" onClick={() => {handleGoToGamePage('landing');}} />

			{/* Modules */}
			<div className="ModulesOverview-content">
				<div className="ModulesOverview-title">
					<span>{getText(playerUiTexts.moduleOverview, languageId)}</span>
				</div>
				<div className="ModulesOverview-modules">
					{modulesData.map((moduleData) => {
						/* Get module status */
						const isUnlocked = checkIfModuleIsUnlocked(moduleData.id, playerData);
						const playerModuleData = getPlayerModuleData(moduleData.id, playerData);
						const isCompleted = Boolean(
							isUnlocked && playerModuleData && playerModuleData.completedDate
						);		

						return (
							<div 
								key={moduleData.id}
								className={'ModulesOverview-module ' + moduleData.id 
									+ (isCompleted ? ' completed' : '')
									+ (!isUnlocked ? ' locked' : '')
								}
								onClick={() => {
									handleGoToModule(isUnlocked, moduleData.id);
								}}
							>
								<span>{getText(moduleData.title, languageId)}</span>
							</div>
						);
					})}
				</div>
			</div>
			
			{/* Language btn */}
			{/* {languagesData.length > 1 &&
				<div className="ModulesOverview-languageBtn" > 
					<Button
						classes={['switch-language']}
						onClick={() => {handleGoToGamePage('choose-language');}}
					/>
				</div>
			} */}
		</div>
	);
};

ModulesOverview.propTypes = {
	languageId: PropTypes.string.isRequired,
	backgroundStatus: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	playerData: PropTypes.object.isRequired,
	handleGoToGamePage: PropTypes.func.isRequired
};

export default ModulesOverview;
